import { useEffect } from "react"
import { Controller, useForm } from "react-hook-form"
import { connect } from "react-redux"
import CustomAutocomplete from "../../UI/Form/CustomAutocmplete"
import Modal from "../../UI/Modal/Modal"
import classes from '../AdminForm.module.css'
import { MdOutlineAlternateEmail } from 'react-icons/md'
import { FaMoneyBillAlt, FaTicketAlt } from 'react-icons/fa'
import { BsPhone } from 'react-icons/bs'
import Input from "../../UI/Form/Input"
import Field from "../../UI/Field/Field"
import CustomButton from "../../UI/CustomButton/CustomButton"
import { getTicketTypes, setTicketTypesData } from "../../../Redux/eventsReducer"

const CreateTicket = (props) => {
    const { onClose, createTicket, events, ticketTypes, getTicketTypes, setTicketTypesData } = props

    const { handleSubmit, reset, control, setValue, watch } = useForm()

    const selectedEvent = watch("eventId")

    const onSubmit = (data) => {
        data.eventId = data.eventId._id
        createTicket({
            ...data,
            ticketType: [{
                _id: data.ticketType._id,
                price: data.price,
                count: data.count
            }]
        })
    }

    useEffect(() => {
        if (selectedEvent) {
            getTicketTypes(selectedEvent._id)
        }
    }, [selectedEvent])

    useEffect(() => {
        reset({
            eventId: null,
            email: "",
            ticketType: null 
        })

        return () => {
            setTicketTypesData([])
        }
    }, [])

    return (
        <Modal title="Create new Ticket's" onClose={onClose}>
            <form className={classes.main} onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="eventId"
                    control={control}
                    defaultValue=""
                    rules={{ required: "Required Field!" }}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <CustomAutocomplete
                            onChange={onChange}
                            value={value}
                            error={error}
                            name="eventId"
                            label="Event"
                            items={events}
                            setValue={setValue}
                        />
                    )}
                />
                {ticketTypes.length > 0 && (
                    <Controller
                        name="ticketType"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Required Field!" }}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <CustomAutocomplete
                                onChange={onChange}
                                value={value}
                                error={error}
                                name="ticketType"
                                label="Ticket Type"
                                items={ticketTypes}
                                setValue={setValue}
                            />
                        )}
                    />
                )}
                <Field>
                    <Controller
                        name="email"
                        control={control}
                        defaultValue=""
                        rules={{ 
                            required: {
                                value: true,
                                message: "Required Field!"
                            },
                            pattern: {
                                value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}/,
                                message: "Invalid Email!"
                            }
                        }}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <Input
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="User Email"  
                                placeholder="customer@gmail.com"
                                startAdornment={true}
                                startAdornmentIcon={<MdOutlineAlternateEmail/>}
                            />
                        )}
                    />
                    <Controller
                        name="phone"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Required Field!" }}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <Input
                                onChange={onChange}
                                value={value}
                                label="Phone Number"
                                placeholder=""
                                startAdornment={true}
                                startAdornmentIcon={<BsPhone/>}
                            />
                        )}
                    />
                </Field>
                <Field>
                    <Controller
                        name="price"
                        control={control}
                        defaultValue={0}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <Input
                                onChange={onChange}
                                value={value}
                                label="Price for 1 ticket"
                                placeholder=""
                                regex="number"
                                startAdornment={true}
                                startAdornmentIcon={<FaMoneyBillAlt/>}
                            />
                        )}
                    />
                    <Controller
                        name="count"
                        control={control}
                        defaultValue={1}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <Input
                                onChange={onChange}
                                value={value}
                                label="Tickets count"
                                placeholder=""
                                regex="number"
                                startAdornment={true}
                                startAdornmentIcon={<FaTicketAlt/>}
                            />
                        )}
                    />
                </Field>
                <CustomButton type="submit">Create</CustomButton>
            </form>
        </Modal>
    )
}

let mapStateToProps = (state) => ({
    events: state.events.events,
    ticketTypes: state.events.ticketTypes
})

export default connect(mapStateToProps, {
    getTicketTypes,
    setTicketTypesData
})(CreateTicket)